import { useEffect, useState } from 'react';
import { FilingFormType } from '../../../utilities/interfaces/FilingFormType';
import { FilingForm } from '../../../utilities/interfaces/FilingForm';
import { ConstructFilingTableTemplate, Filing } from '../../../utilities/interfaces/Filing';
//redux
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getAllFilingTypes } from '../../../features/state/StateFilingFormType-slice';
import { getAllFilingForms } from '../../../features/state/StateFilingForm-slice';
import {
  getAllFilings,
  getFilingsByFormId,
  clearFilingList,
  updateFiling,
} from '../../../features/state/StateFiling-slice';
// table helpers
import { GenerateFilingColumnDefinition } from '../../../components/stateful/table/TableHelper';
import { clearHistories } from '../../../features/state/StateFilingWorkflowHistory-slice';
import { clearStatusActions } from '../../../features/state/StateWorkflowStatusAction-slice';
import { filingAPI } from '../../../utilities/api';

export const useFilingController = (defaultFilingId: string | undefined) => {
  const filings: Filing[] = useAppSelector((state) => state.filings.value);
  const fetchingFilings = useAppSelector((state) => state.filings.fetchingFilings);
  const filingTypes: FilingFormType[] = useAppSelector((state) => state.filingFormTypes.value);
  const filingForms: FilingForm[] = useAppSelector((state) => state.filingForms.value);

  const dispatch = useAppDispatch();

  const [selectedFilingType, setSelectedFilingType] = useState<string>('');
  const [selectedFilingForms, setSelectedFilingForms] = useState<FilingForm[]>([]);
  const [selectedFilingForm, setSelectedFilingForm] = useState<FilingForm | null>(null);
  const [selectedFilingTypeTab, setSelectedFilingTypeTab] = useState<string | undefined>('');
  const [selectedFilingFormTab, setSelectedFilingFormTab] = useState<string | undefined>('');
  const [columns, setColumns] = useState<any>([]);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [selectedFiling, setSelectedFiling] = useState<any>();

  useEffect(() => {
    if (defaultFilingId) {
      fetchAndOpenDefaultFiling(defaultFilingId);
    }
  }, [defaultFilingId])

  const fetchAndOpenDefaultFiling = async (filingId: string) => {
    filingAPI.getFilingById(+filingId).then((filing) => {
      openFiling(filing);
    });
  }

  useEffect(() => {
    if (columns.length < 1) {
      generateColumnData();
    }

    if (filingTypes.length < 1) {
      getFilingTypes();
    }

    if (filingForms.length < 1) {
      getFilingForms();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // this use effect is separate so we don't create an infinite loop fetching filings
  // where filing.pending sets filings to an empty array
  useEffect(() => {
    if (filingTypes.length > 1 && filingForms.length > 1 && selectedFilingForms.length < 1 && (!selectedFilingType || selectedFilingType === null) && !fetchingFilings) {
      selectFilingType({ ...filingTypes[0], text: filingTypes[0].filingFormTypeName });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filingTypes, filingForms, selectedFilingForms])

  const selectFilingType = (event: any) => {
    setSelectedFilingType(event.text);
    getSelectedFilingForms(event.id);
    setSelectedFilingTypeTab(event.text);
  };

  const getSelectedFilingForms = (id: number) => {
    let filingFormItems: FilingForm[] = [];
    filingForms.forEach((item: any, index: number) => {
      if (item.filingFormTypeId === id) {
        filingFormItems.push(item);
      }
    });

    let text = filingFormItems.length > 0 ? filingFormItems[0].filingFormName! : null;
    if (text != null) {
      setSelectedFilingType(text!.match(/[A-Z][a-z]+|[0-9]+/g)!.join(' '));
      // get filings on parent filing type selection
      getFilingsBySelectedForm(filingFormItems[0]?.id!);
    }

    setSelectedFilingForms(filingFormItems);
    filingFormItems.length > 0 && setSelectedFilingFormAndTab(filingFormItems[0], "filingFormName");
  };

  const selectFilingForm = (event: any) => {
    dispatch(getFilingsByFormId(event.id));
    setSelectedFilingType(event.text);
    setSelectedFilingFormAndTab(event, "text");
  };

  const setSelectedFilingFormAndTab = (form: any, key: string) => {
    setSelectedFilingForm(form);
    setSelectedFilingFormTab(form[key]);
  }

  const getFilingsBySelectedForm = (formId: number) => {
    dispatch(getFilingsByFormId(formId));
  };

  const generateColumnData = async () => {
    let columns = await GenerateFilingColumnDefinition(ConstructFilingTableTemplate());
    setColumns(columns);
  };

  // const getFilings = async () => {
  //   dispatch(getAllFilings());
  // };

  const getFilingTypes = () => {
    dispatch(getAllFilingTypes());
  };

  const getFilingForms = async () => {
    dispatch(getAllFilingForms());
  };

  const toggleDialog = () => {
    if (dialogOpen) {
      setDialogOpen(false);
      dispatch(clearHistories());
      dispatch(clearStatusActions());
      getFilingsBySelectedForm(selectedFilingForm?.id! ?? 1);
    }
    else {
      setDialogOpen(true);
    }
  };

  const openFiling = (filing?: any) => {
    if (filing) {
      setSelectedFiling(filing);
    } else {
      setSelectedFiling({});
    }
    toggleDialog();
  };

  const closeFilingForm = () => {
    setSelectedFiling({});
    toggleDialog();
    getFilingsBySelectedForm(selectedFilingForm?.id!);
  };

  return {
    // functions
    selectFilingType,
    selectFilingForm,
    toggleDialog,
    openFiling,
    closeFilingForm,
    // redux
    filings,
    filingTypes,
    fetchingFilings,
    // state
    selectedFilingType,
    selectedFiling,
    selectedFilingForms,
    selectedFilingForm,
    dialogOpen,
    columns,
    // props
    selectedFilingTypeTab,
    selectedFilingFormTab,
  };
};
